module.exports = __webpack_public_path__ + "static/media/google-pca.6685d9b9.png";